import {DataMap} from '@mescius/wijmo.grid';
import {AutoComplete} from '@mescius/wijmo.input';

export const DataMapYesNo = new DataMap([
    { key: "Yes", value: true} ,
    { key: "No", value: false }
], 'value', 'key');
export const DataMapRenewable = new DataMap([
    { key: "Renewable", value: true} ,
    { key: "Not Renewable", value: false }
], 'value', 'key');

export const DataMapRenewalStatus = new DataMap([
    { key: "Renewed", value: 'Renewed'} ,
    { key: "Lost/Cancelled", value: 'LostCancelled' }
], 'value', 'key');

export const DataMapTieringFlag = new DataMap(["Protect", "Improve", "Lose", "Key Account"]);
export const DataMapMethodology = new DataMap(['APTP Ratio','RARC','Repricing Facility (PT)','Manual ERC (PT)','Manual Override']);
export const DataMapLeadFollow = new DataMap(['Lead', 'Follow']);

// Update the FakeEmails array so each address uses one of the three required domains.
export const FakeEmails: string[] = [
  "alex.smith@generali.com",
  "jane.doe@generali.co.uk",
  "michael.jones@generaliasia.com",
  "sarah.connor@generali.com",
  "tom.brown@generali.co.uk",
  "lisa.white@generali.com",
  "chris.green@generaliasia.com",
  "emma.wright@generali.co.uk",
  "david.king@generali.com",
  "olivia.miller@generaliasia.com",
  "noah.johnson@generali.co.uk",
  "ava.davis@generali.com",
  "liam.moore@generali.com",
  "mia.taylor@generaliasia.com",
  "ethan.anderson@generali.co.uk",
  "sophia.thomas@generali.com",
  "benjamin.harris@generaliasia.com",
  "isabella.walker@generali.co.uk",
  "lucas.lewis@generali.com",
  "charlotte.young@generaliasia.com",
  "amelia.scott@generali.com",
  "harry.evans@generali.co.uk",
  "mason.clark@generaliasia.com",
  "ella.hughes@generali.com",
  "logan.turner@generali.co.uk",
  "zoe.adams@generali.com",
  "oscar.bell@generaliasia.com",
  "grace.carter@generali.co.uk",
  "jack.mitchell@generali.com",
  "sienna.parker@generaliasia.com",
  "harper.reed@generali.co.uk",
  "sebastian.ross@generali.com",
  "evelyn.bryant@generaliasia.com",
  "owen.cole@generali.co.uk",
  "nora.fisher@generali.com",
  "cameron.kingston@generali.com",
  "paige.mason@generali.co.uk",
  "ryan.ford@generaliasia.com",
  "lucy.hart@generali.com",
  "zara.knight@generali.co.uk"
];

//
//parentEl.style.color = 'red';
//document.body.appendChild(parentEl);
export let EmailAutoComplete: AutoComplete;
export function initWijmoElements() {
    const parentEl = document.createElement('div');
    EmailAutoComplete = new AutoComplete(parentEl, {
        //displayMemberPath: 'country',
        itemsSource: sortFakeEmailsByDomainThenUser(FakeEmails), isEditable: true, dropDownCssClass: 'tightly-packed-dropdown',
    });
}

/**
 * Return a new array of emails sorted by domain (A) then by user name (B).
 * If inPlace is true, replace the contents of FakeEmails with the sorted order.
 */
function sortFakeEmailsByDomainThenUser(emails: string[]): string[] {
    const sorted = [...emails].sort((a, b) => {
        const [userA = '', domainA = ''] = a.split('@');
        const [userB = '', domainB = ''] = b.split('@');
        const domainCompare = domainA.localeCompare(domainB);
        if (domainCompare !== 0) return domainCompare;
        return userA.localeCompare(userB);
    });
    return sorted;
}
